import React from "react";
import { useHistory } from "react-router-dom";
import { AnimatedHeartbeat } from "../../../../assets";

import "./personalHealthTrackerInitial.css";

const PersonalHealthTrackerInitial: React.FC = (): JSX.Element => {
	const navigate = useHistory();

	return (
		<div className="personal-health-inital-main-container">
			<h3>My Health Score</h3>
			<img src={AnimatedHeartbeat} alt="" />
			<div className="message-container">
				<span>It appears that you have not taken the Health Test yet</span>
				<span className="secondary-text">Take your First Test!</span>
			</div>
			<button className="take-test-button" onClick={() => navigate.push("/personal-health-test")}>
				Take a Test
			</button>
		</div>
	);
};

export default PersonalHealthTrackerInitial;
